import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import apiClient from '../../services/api';
import { LegalPage } from '../landing/LegalPage';

type Status = { state: 'loading' } | { state: 'done'; completedAt: string } | { state: 'unknown' };

/**
 * /data-deletion?code=… is the status URL handed to Meta when someone asks it to
 * delete their Threads data; the code is checked against the API.
 */
export function DataDeletionView() {
    const [params] = useSearchParams();
    const code = params.get('code');
    const [status, setStatus] = useState<Status>({ state: 'loading' });

    useEffect(() => {
        if (!code) return;
        apiClient
            .get(`/social/threads/deletion/${encodeURIComponent(code)}`)
            .then((r) => setStatus({ state: 'done', completedAt: r.data.data.completedAt }))
            .catch(() => setStatus({ state: 'unknown' }));
    }, [code]);

    const notice = !code ? null : (
        <>
            <b>Deletion request {code}</b>
            <div style={{ marginTop: 6 }}>
                {status.state === 'loading' && 'Checking the status…'}
                {status.state === 'done' && `Completed on ${new Date(status.completedAt).toLocaleString('en-GB', { dateStyle: 'long', timeStyle: 'short' })}. HyVay no longer holds the access tokens, profile name, picture or post history of that Threads account.`}
                {status.state === 'unknown' && 'We do not recognise this code. Check the link, or email us and we will look it up.'}
            </div>
        </>
    );
    return <LegalPage kind="deletion" notice={notice} />;
}
